export interface SheetParameterValues {
  readonly currentSheetNumber: string;
  readonly currentSheetNumberPrefix: string;
  readonly currentSheetName: string;
}

export interface ViewportParameterValues {
  readonly viewportName: string;
  readonly viewportNumber: string;
  readonly viewportDescription: string;
  readonly viewportScale: string;
}

export interface DateParameterValues {
  readonly currentDayNumber: string;
  readonly currentDay: string;
  readonly currentMonthNumber: string;
  readonly currentMonth: string;
  readonly currentYear: string;
  readonly currentTime: string;
  readonly currentTimeZone: string;
}

export interface BuildingParameterValues {
  readonly buildingBedroomCount: number;
  readonly buildingBathCount: number;
  readonly buildingConditionedArea: number;
  readonly buildingUnconditionedArea: number;
  readonly buildingGarageArea: number;
  readonly buildingFrontPorchPorticoArea: number;
  readonly buildingRearPorchArea: number;
  readonly buildingCoveredPatioArea: number;
  readonly buildingUncoveredPatioArea: number;
  readonly buildingGarageCount: number;
  readonly buildingStoryCount: number;
  readonly buildingWidth: string;
  readonly buildingDepth: string;
  readonly buildingHeight: string;
}

export interface BuilderParameterValues {
  readonly builderName: string;
  readonly builderAddress: string;
  readonly builderCity: string;
  readonly builderState: string;
  readonly builderZip: string;
}

export interface HomePlanPricingParameterValues {
  readonly homePlanPriceBase: number;
  readonly homePlanPriceOptions: number;
  readonly homePlanPriceDiscount: number;
  readonly homePlanLotPremium: number;
  readonly homePlanPriceTotal: number;
}

export interface HomePlanParameterValues extends HomePlanPricingParameterValues {
  readonly homePlanName: string;
  readonly homePlanSetId: string;
  readonly homePlanStatus: string;
  readonly homePlanShowroomURL: string;
}

export interface LocationHierarchyParameterValues {
  readonly currentLocationName: string;
  readonly companyName: string;
  readonly regionName: string;
  readonly divisionName: string;
  readonly communityName: string;
  readonly phaseName: string;
  readonly multiunitName: string;
}

export interface CommunityParameterValues extends LocationHierarchyParameterValues {
  readonly communityGeneralNotes: string;
  readonly communityGovernmentCodeAndStandards: string;
  readonly communityBuildingCodeAnalysisDesignCriteria: string;
  readonly communityPlanName: string;
}

export interface LotSpecificParameterValues {
  readonly customerName: string;
  readonly lotNumber: string;
  readonly lotAddress: string;
}

export interface MasterPlanParameterValues {
  readonly masterPlanName: string;
}

export interface RoomParameterValues {
  readonly roomReportedName: string;
  readonly roomTagDetails: string;
  readonly roomCeilingHeight: string;
  readonly roomFloorMaterial: string;
  readonly roomDimensions: string;
  readonly roomArea: string;
  readonly roomType: string;
  readonly roomBedroomCount: string;
  readonly roomBathroomCount: string;
  readonly roomGarageCount: string;
}

/**  This value does not vary. The user should not be able to access this parameter to set it. */
export const ActiveOptionStateParameterValue = "FromActiveOptions";

export interface SystemParameterValuesFromDoc
  extends DateParameterValues,
    SheetParameterValues,
    ViewportParameterValues,
    BuilderParameterValues,
    MasterPlanParameterValues,
    HomePlanParameterValues,
    CommunityParameterValues,
    LotSpecificParameterValues,
    RoomParameterValues {}

export interface SystemParameterValues extends SystemParameterValuesFromDoc, BuildingParameterValues {}

export type SystemParameterId = keyof SystemParameterValues;
